<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show">

           <CCol class="mt-3" v-if="!loading">
            <CRow>
              <CCol lg="6">  
                <strong > Personal Information</strong>
              </CCol>
            </CRow>  
            <CRow class="mt-2" >
              <CCol sm="6">
                <Clabel>Email (not required)</Clabel>
                <CInput v-model="form.email" class="mb-1" />
              </CCol>
            </CRow>
            <CRow class="mt-2" >
              <CCol sm="6">
                <Clabel>Phone Number (not required)</Clabel>
                <CInput v-model="form.mobile_phone" class="mb-1" />
              </CCol>
            </CRow>
            <hr>
            <CRow>
              <CCol lg="6">  
                <strong > ICare Information</strong>
              </CCol>
            </CRow>  
            <CRow class="mt-2" >
              <CCol sm="6">
                <Clabel>ICare Youth (not required)</Clabel>
                <b-form-select v-model="form.icareyouth_id" :options="options"></b-form-select>
              </CCol>
            </CRow>
            <hr>
            <CRow>
              <CCol lg="6">  
                <strong > Babtism Information</strong>
              </CCol>
            </CRow>  
            <CRow class="mt-2" >
              <CCol sm="6">
                <Clabel>Babtism Date (not required)</Clabel>
                <CInput v-model="form.baptism_date" type="date"/>
              </CCol>
              <CCol sm="6">
                <Clabel>Babtism Certificate No. (not required)</Clabel>
                <CInput v-model="form.baptism_certificate_no" class="mb-1"/>
              </CCol>
            </CRow>
          </CCol>
          <CCol v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CCol>

        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Set to Graduate</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import moment from 'moment';
import EventBus from '@/eventBus';

import ikid from '@/services/ikid'
import files from '@/services/files'
import icareyouth from '@/services/icareyouth'

export default {
name: 'ikidgraduatemodal',

  data () {
    return {
      show: false,
      loading: false,
      title: 'Default Title',
      mode: '',
      id:'',
      form:{
        email: '',
        mobile_phone: '',
        baptism_date: '',
        baptism_certificate_no: '',
        icareyouth_id: ''
      },
      options:[],
    }
  },
  mounted(){
    
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_IKID_GRADUATE', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.id = params.data;
      }
    });
    this.options = []
    this.loading = true
    icareyouth.getIcare()
    .then(res => {
      for (let i=0; i <= res.data.length-1; i++){
        this.options.push({text: res.data[i].name, value:res.data[i].id})
      }
      this.loading = false
    }).catch((er) =>{
      var params = {title: 'Error', mode:'danger', data:err.response.data.message}
      EventBus.$emit('OPEN_MODAL_ALERT', params)
      this.loading = false
    })    
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
      
    },
    create(){
      if( this.form.baptism_date != '' ){this.form.baptism_date  = moment(this.form.baptism_date).format ('DD/MM/YYYY')} 
      this.show = false;
        ikid.graduate(this.id, this.form)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>